import React from "react";
import { useTranslation } from "react-i18next";


const HeaderTitle = ({ children }) => <span className="scp-embed-header-title scp-text-3xl">{children}</span>

export const Header = ({ displayHeader, outsidePoweredBy, data, headerImageSizeClasses, displayPoweredByScoopIt }) => {
    const { t } = useTranslation();
    return <React.Fragment>
        {displayHeader && <div className="scp-embed-header scp-p-4 scp-rounded-sm scp-shadow-md scp-embed-block scp-flex scp-gap-4 scp-relative">
            {data.image_url && <div className={headerImageSizeClasses}><img className={headerImageSizeClasses} src={data.image_url} /></div>}
            <div className="scp-flex-1 scp-flex scp-flex-col scp-gap-2">
                {data.url && <a href={data.url} target="_blank" className="scp-embed-link"><HeaderTitle>{data.name}</HeaderTitle></a>}
                {!data.url && <HeaderTitle>{data.name}</HeaderTitle>}
                <Description data={data} />
                {data.creator && <div className="scp-embed-header-curatedBy">{t('curated_by')} <a className="scp-embed-link" href={data.creator.url}>{data.creator.name}</a></div>}
            </div>
            {
                displayPoweredByScoopIt && data.creator && !outsidePoweredBy && <div className="scp-absolute scp-right-4 scp-bottom-4"><PoweredByScoopIt /></div>
            }
        </div>}
        {
            displayPoweredByScoopIt && data.creator && (outsidePoweredBy || !displayHeader) && <PoweredByScoopIt />
        }
    </React.Fragment>
}

const Description = ({ data }) => {
    if (!data.description) {
        return null;
    }
    if (data.html_description) {
        return <div className="scp-embed-header-description" dangerouslySetInnerHTML={{ __html: data.description }} />
    } else {
        return <div className="scp-embed-header-description">{data.description}</div>
    }
}

export const PoweredByScoopIt = () => {
    const { t } = useTranslation();

    return <div className="scp-flex scp-justify-end scp-items-center scp-gap-2 scp-embed-powered-by">
        <div>{t('powered_by')}</div>
        <a className="scp-contents" href="https://www.scoop.it/" target="_blank"><img className={"scp-h-auto scp-w-16"} src="https://www.scoop.it/resources/img/V4/scoopit/logo-scoop-it-black_cyan.svg" /></a>
    </div>
}